import './styles.css'

import React from 'react'

import SetPlaceholder from '../../set_placeholder'

export default class Duration extends React.Component {
  render () {
    const { app, node } = this.props
    const data = node.data || {}
    return (
      <div
        onClick={ev =>
          app.toggleFloater(ev.target, 'duration-picker', {
            nodeId: node.id
          })
        }
      >
        {data.duration && <div className='actual-data'>{data.duration}</div>}
        {!data.duration && <SetPlaceholder />}
      </div>
    )
  }
}
